
function Contact() {
  return (<div className="container">
    <h2>Contact</h2>

    <p>Last updated:  August 10th, 2025</p>
    <p>
      Please send an email to : tryciaspas@gmail.com
    </p>

  </div>);
}
export default Contact;
